import React from 'react';
import { SpaceProps } from 'styled-system';
import Tooltip, { TooltipChildren, TooltipPosition } from '@ingka/tooltip';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/tooltip/dist/style.css';
import '@ingka/focus/dist/style.css';

//This is the Skapa component "Tooltip"

type Props = SpaceProps & {
  children?: TooltipChildren;
  position?: TooltipPosition;
  tooltipText: string;
  describedById?: string;
  interactiveCustomTrigger?: boolean;
  ssrIcon?: (...args: any[]) => any;
  tooltipButtonLabel?: string;
  onClick?: (...args: any[]) => any;
  boundaryContainerID?: string;
};

const SkapaTooltip = ({
  children,
  position,
  tooltipText,
  describedById,
  interactiveCustomTrigger,
  ssrIcon,
  tooltipButtonLabel,
  onClick,
  boundaryContainerID
}: Props) => {
  return (
    <Tooltip
      position={position}
      tooltipText={tooltipText}
      describedById={describedById}
      interactiveCustomTrigger={interactiveCustomTrigger}
      ssrIcon={ssrIcon}
      tooltipButtonLabel={tooltipButtonLabel}
      onClick={onClick}
      boundaryContainerID={boundaryContainerID}
    >
      {children}
    </Tooltip>
  );
};

export default SkapaTooltip;
